export default __webpack_public_path__ + "static/media/5.13cbe8bd.jpg";